import { SWATCHES, Reveal } from "@/components/site/shared";
import { Marquee } from "@/components/site/Marquee";

const YES = ["Retro & vintage cuts", "Nostalgic banquet hall vibes", "Velvet, corduroy, & suede are all welcome"];
const NO = ["Anything you can't dance in", "Denim suits are encouraged, jeans are not"];
const OUTFITS = [
  "Knee-length dress or Jumpsuit",
  "Sportscoat + Turtleneck or Vest + Slacks",
  "Suit + Colorful Tie or Flowy Dress ",
];

export default function DressCode() {
  return (
    <div>
      <section className="pt-32 md:pt-40 pb-16 max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <Reveal>
            <p className="overline text-orange">Dress Code & Inspo</p>
            <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-ink mt-4 leading-[0.95]">
              Semi-formal <br /> to Festive
            </h1>
            <p className="font-body text-lg text-ink/80 mt-6 max-w-xl">
              A little retro, if you're in the mood. We are going for an old-school Pennsylvania party with a
              subtle nod to the 60s and 70s. Think classic styles but with fun colors, patterns and a little
              personality.
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            <p className="overline text-ink/60 mb-6">Our Palette</p>
            <div className="flex flex-wrap gap-6 md:gap-8">
              {SWATCHES.filter((s) => !s.secondary).map((s) => (
                <div
                  key={s.hex}
                  data-testid={`swatch-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="w-24 md:w-28 flex flex-col items-center text-center group"
                >
                  <div
                    className="w-20 h-20 md:w-24 md:h-24 rounded-full border-2 border-ink transition-transform duration-200 group-hover:-translate-y-1 group-hover:rotate-6"
                    style={{ backgroundColor: s.hex, boxShadow: "4px 4px 0 #6E523A" }}
                  />
                  <p className="font-grotesk font-bold text-sm text-ink mt-3 leading-tight">{s.name}</p>
                </div>
              ))}
            </div>
            <div className="flex items-start flex-wrap gap-6 md:gap-8 mt-8">
              <span className="overline text-ink/50 w-full">+ Accents</span>
              {SWATCHES.filter((s) => s.secondary).map((s) => (
                <div
                  key={s.hex}
                  data-testid={`swatch-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="w-20 flex flex-col items-center text-center group"
                >
                  <div
                    className="w-14 h-14 md:w-16 md:h-16 rounded-full border-2 border-ink transition-transform duration-200 group-hover:-translate-y-1 group-hover:-rotate-6"
                    style={{ backgroundColor: s.hex, boxShadow: "3px 3px 0 #6E523A" }}
                  />
                  <p className="font-grotesk font-bold text-xs text-ink/70 mt-3 leading-tight">{s.name}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* yes / no + outfits */}
      <section className="grid md:grid-cols-2">
        <div className="bg-yellow p-10 md:p-20 flex flex-col justify-center">
          <Reveal>
            <p className="overline text-ink/60">A few ideas</p>
            <h2 className="font-display text-4xl md:text-5xl text-ink mt-3">Outfit inspiration</h2>
            <p className="font-body text-ink/80 mt-4 max-w-md">
              Dress to theme or wear something from your closet. As long as you're comfortable!
            </p>
            <div className="mt-8 space-y-4">
              {OUTFITS.map((o, i) => (
                <div
                  key={o}
                  className="card-retro bg-cream p-5 flex items-center gap-4 transition-transform duration-200 hover:-translate-y-1"
                  data-testid={`outfit-${i}`}
                >
                  <span className="font-grotesk font-bold text-ink text-lg">{o}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="bg-avocado text-cream p-10 md:p-20">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl">Yes, please</h2>
            <ul className="mt-6 space-y-3 font-body text-lg">
              {YES.map((y) => (
                <li key={y} className="flex gap-3">
                  <span className="text-yellow font-bold">✦</span> {y}
                </li>
              ))}
           
            </ul>
            <h2 className="font-display text-4xl md:text-5xl mt-12">Maybe skip</h2>
            <ul className="mt-6 space-y-3 font-body text-lg text-cream/85">
              {NO.map((n) => (
                <li key={n} className="flex gap-3">
                  <span className="text-red font-bold">✕</span> {n}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <Marquee text="COME IN COLOR" accent="FESTIVE TO SEMI-FORMAL" bg="#FF6E00" />
    </div>
  );
}
